import { CALL_API } from 'middleware/api';
import { TierPeriod } from '../entities';
import { GET_STRIPE_CREDITS_FAILURE, GET_STRIPE_CREDITS_REQUEST, GET_STRIPE_CREDITS_SUCCESS, GET_STRIPE_SUBSCRIPTION_PURCHASE_PREVIEW_FAILURE, GET_STRIPE_SUBSCRIPTION_PURCHASE_PREVIEW_REQUEST, GET_STRIPE_SUBSCRIPTION_PURCHASE_PREVIEW_SUCCESS, } from './types';
export const setIsPlatformPaySupported = (isPlatformPaySupported) => ({
    type: 'SET_IS_PLATFORM_PAY_SUPPORTED',
    isPlatformPaySupported,
});
export const getStripePrices = () => ({
    [CALL_API]: {
        endpoint: `/stripe/prices`,
        method: 'GET',
        types: [
            'GET_STRIPE_PRICES_REQUEST',
            'GET_STRIPE_PRICES_SUCCESS',
            'GET_STRIPE_PRICES_FAILURE',
        ],
    },
});
export const getStripeCustomer = () => ({
    [CALL_API]: {
        endpoint: `/stripe/customer`,
        method: 'GET',
        types: [
            'GET_STRIPE_CUSTOMER_REQUEST',
            'GET_STRIPE_CUSTOMER_SUCCESS',
            'GET_STRIPE_CUSTOMER_FAILURE',
        ],
    },
});
export const createStripeCustomer = () => ({
    [CALL_API]: {
        endpoint: `/stripe/customer`,
        method: 'POST',
        types: [
            'POST_STRIPE_CUSTOMER_REQUEST',
            'POST_STRIPE_CUSTOMER_SUCCESS',
            'POST_STRIPE_CUSTOMER_FAILURE',
        ],
    },
});
export const setUpIntent = () => ({
    [CALL_API]: {
        endpoint: `/stripe/setup-intent`,
        method: 'POST',
        types: [
            'SET_UP_STRIPE_INTENT_REQUEST',
            'SET_UP_STRIPE_INTENT_SUCCESS',
            'SET_UP_STRIPE_INTENT_FAILURE',
        ],
        muteAlert: true,
    },
});
export const setUpIntentConfirm = (paymentMethodId) => ({
    [CALL_API]: {
        endpoint: `/stripe/setup-intent/confirm`,
        method: 'POST',
        body: JSON.stringify({ paymentMethodId }),
        muteAlert: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'SET_UP_STRIPE_INTENT_CONFIRM_REQUEST',
            'SET_UP_STRIPE_INTENT_CONFIRM_SUCCESS',
            'SET_UP_STRIPE_INTENT_CONFIRM_FAILURE',
        ],
    },
});
export const subscribeViaStripe = (productId, couponId, skipFreeTrial, ach) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription`,
        method: 'POST',
        body: JSON.stringify({
            priceId: productId,
            couponId,
            skipFreeTrial,
            ach,
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'SUBSCRIBE_VIA_STRIPE_REQUEST',
            'SUBSCRIBE_VIA_STRIPE_SUCCESS',
            'SUBSCRIBE_VIA_STRIPE_FAILURE',
        ],
        muteAlert: true,
    },
});
export const changeAchPaymentMethod = (ach) => ({
    [CALL_API]: {
        endpoint: `/stripe/ach/payment-method`,
        method: 'PATCH',
        body: JSON.stringify(ach),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'CHANGE_ACH_PAYMENT_METHOD_REQUEST',
            'CHANGE_ACH_PAYMENT_METHOD_SUCCESS',
            'CHANGE_ACH_PAYMENT_METHOD_FAILURE',
        ],
        muteAlert: true,
    },
});
export const getAchEligibleAccounts = () => ({
    [CALL_API]: {
        endpoint: `/stripe/ach/eligible-accounts`,
        method: 'GET',
        types: [
            'GET_ACH_ELIGIBLE_ACCOUNTS_REQUEST',
            'GET_ACH_ELIGIBLE_ACCOUNTS_SUCCESS',
            'GET_ACH_ELIGIBLE_ACCOUNTS_FAILURE',
        ],
        muteAlert: true,
    },
});
export const cancelStripeSubscription = () => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/cancel`,
        method: 'POST',
        types: [
            'CANCEL_STRIPE_SUBSCRIPTION_REQUEST',
            'CANCEL_STRIPE_SUBSCRIPTION_SUCCESS',
            'CANCEL_STRIPE_SUBSCRIPTION_FAILURE',
        ],
    },
});
export const extendTrialViaStripe = () => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/extend-trial`,
        method: 'POST',
        types: [
            'EXTEND_TRIAL_VIA_STRIPE_REQUEST',
            'EXTEND_TRIAL_VIA_STRIPE_SUCCESS',
            'EXTEND_TRIAL_VIA_STRIPE_FAILURE',
        ],
    },
});
export const reactivateStripeSubscription = () => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/reactivate`,
        method: 'POST',
        types: [
            'REACTIVATE_STRIPE_SUBSCRIPTION_REQUEST',
            'REACTIVATE_STRIPE_SUBSCRIPTION_SUCCESS',
            'REACTIVATE_STRIPE_SUBSCRIPTION_FAILURE',
        ],
    },
});
export const changeSubscriptionViaStripe = (productId, couponId, prorationDate, isRefundFlow) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription`,
        method: 'PATCH',
        body: JSON.stringify({
            priceId: productId,
            couponId,
            prorationDate,
            isRefundFlow,
        }),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'CHANGE_SUBSCRIPTION_VIA_STRIPE_REQUEST',
            'CHANGE_SUBSCRIPTION_VIA_STRIPE_SUCCESS',
            'CHANGE_SUBSCRIPTION_VIA_STRIPE_FAILURE',
        ],
        muteAlert: true,
    },
});
export const getStripeSubscriptionPurchasePreview = (body) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/preview`,
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            GET_STRIPE_SUBSCRIPTION_PURCHASE_PREVIEW_REQUEST,
            GET_STRIPE_SUBSCRIPTION_PURCHASE_PREVIEW_SUCCESS,
            GET_STRIPE_SUBSCRIPTION_PURCHASE_PREVIEW_FAILURE,
        ],
        muteAlert: false,
    },
});
export const refundStripeSubscription = (body) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/refund`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        types: [
            'REFUND_STRIPE_SUBSCRIPTION_REQUEST',
            'REFUND_STRIPE_SUBSCRIPTION_SUCCESS',
            'REFUND_STRIPE_SUBSCRIPTION_FAILURE',
        ],
    },
});
export const clearStripeFailedPayment = () => ({
    type: 'CLEAR_STRIPE_FAILED_PAYMENT',
});
export const clearStripeSeatBasedFailedPayment = () => ({
    type: 'CLEAR_STRIPE_SEAT_BASED_FAILED_PAYMENT',
});
export const retryStripeSubscriptionPayment = (options) => ({
    [CALL_API]: {
        endpoint: `/stripe/subscription/pay`,
        method: 'POST',
        ...(options?.seatBased && {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ seatBased: true }),
        }),
        types: [
            'RETRY_STRIPE_SUBSCRIPTION_PAYMENT_REQUEST',
            'RETRY_STRIPE_SUBSCRIPTION_PAYMENT_SUCCESS',
            'RETRY_STRIPE_SUBSCRIPTION_PAYMENT_FAILURE',
        ],
        muteAlert: true,
    },
});
export const getStripeCredit = () => ({
    [CALL_API]: {
        endpoint: `/stripe/credit`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            GET_STRIPE_CREDITS_REQUEST,
            GET_STRIPE_CREDITS_SUCCESS,
            GET_STRIPE_CREDITS_FAILURE,
        ],
    },
});
